import { render } from "./SubroutesTemplate.vue?vue&type=template&id=247ae228"
import script from "./SubroutesTemplate.vue?vue&type=script&lang=js"
export * from "./SubroutesTemplate.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__